import React from 'react';
import { LiveJoinUrl } from './LiveJoinUrl';
import { LiveJoinQR } from './LiveJoinQR';
import { LiveCountdown } from './LiveCountdown';
import { LiveJoinInfo } from './LiveJoinInfo';
import styles from './LiveHeader.module.scss';

export function LiveHeader() {
  return (
    <div className={styles.liveJoin}>
      <LiveCountdown />
      <LiveJoinUrl />
      <LiveJoinQR />
      <LiveJoinInfo />
    </div>
  );
}
